// src/components/PromoBannerWithModal.jsx
import React, { useState, useEffect } from 'react';
import PromoModalDynamic from './PromoModalDynamic';
import products from '../data/promoProducts.json'; // your JSON file

const PromoBannerWithModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    if (products && products.length > 0) {
      // Pick a random product each refresh
      const randomProduct = products[Math.floor(Math.random() * products.length)];
      setProduct(randomProduct);
    }
    setShowModal(true); // show every refresh
  }, []);

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      {showModal && product && (
        <PromoModalDynamic
          product={product} // pass a single product object
          onClose={handleClose}
        />
      )}
    </>
  );
};

export default PromoBannerWithModal;